module.exports = {
      id: "filter-icon-usage",
      viewBox: "0 0 13 14",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#filter-icon",
      toString: function () {
        return this.url;
      }
    }